

export const moduleActions = {
    PEDIDO_ALTA: "PEDIDO_ALTA",
    PEDIDO_ELIMINAR: "PEDIDO_ELIMINAR",
    PEDIDO_DUPLICAR: "PEDIDO_DUPLICAR",
    PEDIDO_CANCELAR: "PEDIDO_CANCELAR",
    PEDIDO_EDITAR: "PEDIDO_EDITAR",
    PEDIDO_ELIMINAR_DOCUMENTO: "PEDIDO_ELIMINAR_DOCUMENTO",
    PEDIDO_ACCIONES: "PEDIDO_ACCIONES",
    COMENTARIO: "COMENTARIO",

    PLAN_TRANSPORTE_ALTA: "PLAN_TRANSPORTE_ALTA",
    PLAN_TRANSPORTE_EDITAR: "PLAN_TRANSPORTE_EDITAR",
    PLAN_TRANSPORTE_REENVIARPT: "PLAN_TRANSPORTE_REENVIARPT",
    PLAN_TRANSPORTE_VISUALIZAR_LIST: "PLAN_TRANSPORTE_VISUALIZAR_LIST",
    PLAN_TRANSPORTE_VISUALIZAR_DET: "PLAN_TRANSPORTE_VISUALIZAR_DET",

    ADMIN_VISUALIZAR: "ADMIN_VISUALIZAR",
    ADMIN_USUARIO_ALTA: "ADMIN_USUARIO_ALTA",
    ADMIN_USUARIO_EDITAR: "ADMIN_USUARIO_EDITAR",

    SHIPMENT_DETALLE: "SHIPMENT_DETALLE",
    PEDIDO_DETALLE: "PEDIDO_DETALLE",

    MI_PERFIL_USER_LIST: "MI_PERFIL_USER_LIST",
    MI_PERFIL_USER_EDIT: "MI_PERFIL_USER_EDIT",

    ADMIN_ALERTA_EDITAR: "ADMIN_ALERTA_EDITAR",
    ADMIN_ALERTA_LIST: "ADMIN_ALERTA_EDITAR"
}

/**
 * 1 "Administrador"
 * 2 "Super user"
 * 3 "Executive OPS / OKAM"
 * 4 "Executive sales"
 * 5 "Cliente ejecutivo de compras"
 * 6 "Cliente"
 */

export const roleModuleFilter =
    [
        {
            Rol: 1,
            Full: true,
            Actions: []
        },
        {
            Rol: 2,
            Full: true,
            Actions: []
        }, {
            Rol: 3,
            Filters: [moduleActions.PEDIDO_ELIMINAR,
            moduleActions.PEDIDO_DUPLICAR,
            moduleActions.PEDIDO_CANCELAR,
            moduleActions.PEDIDO_EDITAR,
            moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
            moduleActions.PLAN_TRANSPORTE_EDITAR,
            moduleActions.PLAN_TRANSPORTE_REENVIARPT,
            moduleActions.COMENTARIO]
        }, {
            Rol: 4,
            Filters:
                [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
                moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
                moduleActions.COMENTARIO,
                moduleActions.PEDIDO_ELIMINAR_DOCUMENTO
                ]
        }, {
            Rol: 5,
            Filters: [moduleActions.COMENTARIO, moduleActions.PEDIDO_ELIMINAR_DOCUMENTO]
        }, {
            Rol: 6,
            Filters: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
            moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
            moduleActions.COMENTARIO,
            moduleActions.PEDIDO_ELIMINAR_DOCUMENTO]
        }
    ]

export const roleCustomerFilter =
    [
        {
            Rol: 1,
            Full: true,
            Actions: []
        },
        {
            Rol: 2,
            Full: true,
            Actions: []
        }, {
            Rol: 3,
            Filters: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
            moduleActions.SHIPMENT_DETALLE,
            moduleActions.PEDIDO_DETALLE]
        }, {
            Rol: 4,
            Filters:
                [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
                moduleActions.SHIPMENT_DETALLE,
                moduleActions.PEDIDO_DETALLE]
        }, {
            Rol: 5,
            Filters: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
            moduleActions.SHIPMENT_DETALLE,
            moduleActions.PEDIDO_DETALLE]
        }, {
            Rol: 6,
            Filters: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
            moduleActions.SHIPMENT_DETALLE,
            moduleActions.PEDIDO_DETALLE]
        }
    ]

export const roleModuleAction =
    [
        {
            Rol: 1,
            Full: true,
            Actions: [moduleActions.ADMIN_VISUALIZAR,
            moduleActions.ADMIN_USUARIO_ALTA,
            moduleActions.ADMIN_USUARIO_EDITAR]
        },
        {
            Rol: 2,
            Actions: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
            moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
            moduleActions.PEDIDO_ELIMINAR,
            moduleActions.PEDIDO_DUPLICAR,
            moduleActions.PEDIDO_CANCELAR,
            moduleActions.PEDIDO_EDITAR,
            moduleActions.PEDIDO_ALTA,
            moduleActions.PEDIDO_ACCIONES,
            moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
            moduleActions.PLAN_TRANSPORTE_EDITAR,
            moduleActions.PLAN_TRANSPORTE_REENVIARPT,
            moduleActions.PLAN_TRANSPORTE_ALTA,
            moduleActions.COMENTARIO]
        }, {
            Rol: 3,
            Actions: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
            moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET,
            moduleActions.PEDIDO_ELIMINAR,
            moduleActions.PEDIDO_DUPLICAR,
            moduleActions.PEDIDO_CANCELAR,
            moduleActions.PEDIDO_EDITAR,
            moduleActions.PEDIDO_ALTA,
            moduleActions.PEDIDO_ACCIONES,
            moduleActions.PEDIDO_ELIMINAR_DOCUMENTO,
            moduleActions.PLAN_TRANSPORTE_EDITAR,
            moduleActions.PLAN_TRANSPORTE_REENVIARPT,
            moduleActions.PLAN_TRANSPORTE_ALTA,
            moduleActions.COMENTARIO]
        }, {
            Rol: 4,
            Actions:
                [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
                moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET
                ]
        }, {
            Rol: 5,
            Actions: []
        }, {
            Rol: 6,
            Actions: [moduleActions.PLAN_TRANSPORTE_VISUALIZAR_LIST,
            moduleActions.PLAN_TRANSPORTE_VISUALIZAR_DET
            ]
        }
    ]